import { applyRESTQueries } from "../helpers";
export class BaseRESTConnection {
    constructor(name, meta) {
        this.name = name;
        this.meta = meta;
    }
    applyQuery(message) {
        return applyRESTQueries(this.name, message, this.meta);
    }
}
//# sourceMappingURL=BaseRESTConnection.js.map